/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `NA` - None
 * * `Edit` - Edit
 * * `DownloadDocument` - Download Document
 * * `DownloadCMS` - Download CMS
 * * `Handover` - Handover
 * * `Extend` - Extend
 */
export enum SystemActionsEnum {
    NA = 'NA',
    EDIT = 'Edit',
    DOWNLOAD_DOCUMENT = 'DownloadDocument',
    DOWNLOAD_CMS = 'DownloadCMS',
    HANDOVER = 'Handover',
    EXTEND = 'Extend',
}
